import { palette5 } from '../utils/colorPalette';
import type { HairStyle } from '../types';

export type HairSVGParts = { back: string; front: string };

// ─── 모든 좌표는 192×288 viewBox 기준 ────────────────────────────────────
// AI 캐릭터 머리 위치: x=44-148 (104 wide), y=15-130 (115 tall)
//   - 정수리: y=15
//   - 이마: y=40-65
//   - 눈: y=70-95
//   - 턱: y=130
// 헤어는 이 영역 위/주변에 그려짐.

function hairBuns(c: string): HairSVGParts {
  const h = palette5(c);
  return {
    // 옆머리 (귀 옆)
    back: `
      <rect x="36" y="50" width="10" height="90" fill="${h.deep}"/>
      <rect x="38" y="50" width="8" height="90" fill="${h.shadow}"/>
      <rect x="40" y="60" width="3" height="60" fill="${h.base}"/>
      <rect x="146" y="50" width="10" height="90" fill="${h.deep}"/>
      <rect x="146" y="50" width="8" height="90" fill="${h.shadow}"/>
      <rect x="149" y="60" width="3" height="60" fill="${h.base}"/>
    `,
    front: `
      <!-- 왼쪽 헤어번 -->
      <rect x="22" y="22" width="6" height="2" fill="${h.deep}"/>
      <rect x="28" y="18" width="22" height="3" fill="${h.deep}"/>
      <rect x="22" y="21" width="32" height="3" fill="${h.shadow}"/>
      <rect x="20" y="24" width="36" height="28" fill="${h.base}"/>
      <rect x="20" y="52" width="36" height="3" fill="${h.shadow}"/>
      <rect x="22" y="26" width="14" height="6" fill="${h.light}"/>
      <rect x="24" y="26" width="8" height="3" fill="${h.rim}"/>
      <!-- 오른쪽 헤어번 -->
      <rect x="164" y="22" width="6" height="2" fill="${h.deep}"/>
      <rect x="142" y="18" width="22" height="3" fill="${h.deep}"/>
      <rect x="138" y="21" width="32" height="3" fill="${h.shadow}"/>
      <rect x="136" y="24" width="36" height="28" fill="${h.base}"/>
      <rect x="136" y="52" width="36" height="3" fill="${h.shadow}"/>
      <rect x="156" y="26" width="14" height="6" fill="${h.light}"/>
      <rect x="160" y="26" width="8" height="3" fill="${h.rim}"/>
      <!-- 앞머리 (이마 덮음) -->
      <rect x="50" y="20" width="92" height="6" fill="${h.deep}"/>
      <rect x="46" y="26" width="100" height="8" fill="${h.shadow}"/>
      <rect x="46" y="34" width="100" height="20" fill="${h.base}"/>
      <rect x="48" y="34" width="96" height="3" fill="${h.light}"/>
      <rect x="60" y="36" width="20" height="3" fill="${h.rim}"/>
      <rect x="100" y="36" width="20" height="3" fill="${h.rim}"/>
      <rect x="46" y="54" width="100" height="14" fill="${h.base}"/>
      <rect x="46" y="54" width="100" height="3" fill="${h.shadow}"/>
      <!-- 들쭉날쭉 끝 -->
      <rect x="52" y="60" width="4" height="8" fill="${h.deep}"/>
      <rect x="72" y="60" width="6" height="10" fill="${h.deep}"/>
      <rect x="92" y="60" width="4" height="8" fill="${h.deep}"/>
      <rect x="112" y="60" width="6" height="10" fill="${h.deep}"/>
      <rect x="134" y="60" width="4" height="8" fill="${h.deep}"/>
      <rect x="46" y="68" width="100" height="2" fill="${h.deep}"/>
    `,
  };
}

function hairTwintails(c: string): HairSVGParts {
  const h = palette5(c);
  return {
    back: `
      <!-- 머리 뒤쪽 베이스 (정수리부터) -->
      <rect x="36" y="40" width="120" height="100" fill="${h.shadow}"/>
      <rect x="40" y="40" width="112" height="100" fill="${h.base}"/>
      <!-- 왼쪽 양갈래 -->
      <rect x="14" y="100" width="32" height="6" fill="${h.deep}"/>
      <rect x="10" y="106" width="36" height="120" fill="${h.shadow}"/>
      <rect x="14" y="106" width="32" height="120" fill="${h.base}"/>
      <rect x="18" y="110" width="6" height="80" fill="${h.light}"/>
      <rect x="22" y="110" width="3" height="60" fill="${h.rim}"/>
      <rect x="10" y="222" width="36" height="6" fill="${h.deep}"/>
      <rect x="12" y="228" width="8" height="6" fill="${h.shadow}"/>
      <rect x="24" y="228" width="8" height="6" fill="${h.shadow}"/>
      <rect x="36" y="228" width="8" height="6" fill="${h.shadow}"/>
      <!-- 오른쪽 양갈래 -->
      <rect x="146" y="100" width="32" height="6" fill="${h.deep}"/>
      <rect x="146" y="106" width="36" height="120" fill="${h.shadow}"/>
      <rect x="146" y="106" width="32" height="120" fill="${h.base}"/>
      <rect x="148" y="110" width="6" height="80" fill="${h.light}"/>
      <rect x="146" y="222" width="36" height="6" fill="${h.deep}"/>
      <rect x="148" y="228" width="8" height="6" fill="${h.shadow}"/>
      <rect x="160" y="228" width="8" height="6" fill="${h.shadow}"/>
      <rect x="172" y="228" width="8" height="6" fill="${h.shadow}"/>
    `,
    front: `
      <rect x="44" y="20" width="104" height="6" fill="${h.deep}"/>
      <rect x="40" y="26" width="112" height="10" fill="${h.shadow}"/>
      <rect x="40" y="36" width="112" height="20" fill="${h.base}"/>
      <rect x="44" y="36" width="104" height="4" fill="${h.light}"/>
      <rect x="60" y="38" width="20" height="3" fill="${h.rim}"/>
      <rect x="108" y="38" width="20" height="3" fill="${h.rim}"/>
      <!-- 앞머리 양옆이 V자로 살짝 갈라짐 -->
      <rect x="40" y="56" width="112" height="14" fill="${h.base}"/>
      <rect x="40" y="56" width="112" height="3" fill="${h.shadow}"/>
      <rect x="48" y="62" width="6" height="10" fill="${h.deep}"/>
      <rect x="68" y="62" width="4" height="8" fill="${h.deep}"/>
      <rect x="86" y="62" width="6" height="10" fill="${h.deep}"/>
      <rect x="106" y="62" width="4" height="8" fill="${h.deep}"/>
      <rect x="124" y="62" width="6" height="10" fill="${h.deep}"/>
      <rect x="40" y="68" width="112" height="2" fill="${h.deep}"/>
    `,
  };
}

function hairPony(c: string): HairSVGParts {
  const h = palette5(c);
  return {
    back: `
      <!-- 머리 뒤 베이스 -->
      <rect x="36" y="40" width="120" height="100" fill="${h.shadow}"/>
      <rect x="40" y="40" width="112" height="100" fill="${h.base}"/>
      <!-- 뒤로 묶인 포니테일 (오른쪽 위에서 흘러내림) -->
      <rect x="160" y="50" width="14" height="6" fill="${h.deep}"/>
      <rect x="156" y="56" width="22" height="140" fill="${h.shadow}"/>
      <rect x="160" y="56" width="18" height="140" fill="${h.base}"/>
      <rect x="162" y="60" width="6" height="100" fill="${h.light}"/>
      <rect x="156" y="194" width="22" height="6" fill="${h.deep}"/>
      <!-- 묶음 매듭 (어두운 띠) -->
      <rect x="148" y="76" width="22" height="6" fill="#1a1a1a"/>
    `,
    front: `
      <rect x="44" y="20" width="104" height="6" fill="${h.deep}"/>
      <rect x="40" y="26" width="112" height="10" fill="${h.shadow}"/>
      <rect x="40" y="36" width="112" height="20" fill="${h.base}"/>
      <rect x="44" y="36" width="104" height="4" fill="${h.light}"/>
      <rect x="60" y="38" width="20" height="3" fill="${h.rim}"/>
      <rect x="108" y="38" width="20" height="3" fill="${h.rim}"/>
      <rect x="40" y="56" width="14" height="50" fill="${h.shadow}"/>
      <rect x="44" y="56" width="10" height="50" fill="${h.base}"/>
      <rect x="40" y="56" width="112" height="14" fill="${h.base}"/>
      <rect x="40" y="56" width="112" height="3" fill="${h.shadow}"/>
      <rect x="50" y="62" width="28" height="8" fill="${h.deep}"/>
      <rect x="92" y="62" width="14" height="8" fill="${h.deep}"/>
      <rect x="120" y="62" width="28" height="8" fill="${h.deep}"/>
      <rect x="40" y="68" width="112" height="2" fill="${h.deep}"/>
    `,
  };
}

function hairBob(c: string): HairSVGParts {
  const h = palette5(c);
  return {
    back: `
      <rect x="28" y="40" width="136" height="100" fill="${h.shadow}"/>
      <rect x="32" y="40" width="128" height="100" fill="${h.base}"/>
      <rect x="36" y="50" width="6" height="70" fill="${h.light}"/>
      <rect x="150" y="50" width="6" height="70" fill="${h.light}"/>
      <rect x="42" y="56" width="3" height="50" fill="${h.rim}"/>
      <rect x="146" y="56" width="3" height="50" fill="${h.rim}"/>
      <rect x="28" y="132" width="14" height="14" fill="${h.deep}"/>
      <rect x="150" y="132" width="14" height="14" fill="${h.deep}"/>
      <rect x="40" y="140" width="112" height="6" fill="${h.deep}"/>
    `,
    front: `
      <rect x="44" y="20" width="104" height="6" fill="${h.deep}"/>
      <rect x="40" y="26" width="112" height="14" fill="${h.shadow}"/>
      <rect x="40" y="40" width="112" height="14" fill="${h.base}"/>
      <rect x="44" y="40" width="104" height="3" fill="${h.light}"/>
      <rect x="68" y="42" width="20" height="3" fill="${h.rim}"/>
      <rect x="106" y="42" width="20" height="3" fill="${h.rim}"/>
      <rect x="40" y="54" width="112" height="16" fill="${h.base}"/>
      <rect x="40" y="54" width="112" height="3" fill="${h.shadow}"/>
      <rect x="48" y="60" width="6" height="10" fill="${h.deep}"/>
      <rect x="68" y="60" width="4" height="8" fill="${h.deep}"/>
      <rect x="88" y="60" width="6" height="10" fill="${h.deep}"/>
      <rect x="108" y="60" width="4" height="8" fill="${h.deep}"/>
      <rect x="128" y="60" width="6" height="10" fill="${h.deep}"/>
      <rect x="40" y="68" width="112" height="2" fill="${h.deep}"/>
    `,
  };
}

function hairLong(c: string): HairSVGParts {
  const h = palette5(c);
  return {
    back: `
      <rect x="20" y="30" width="152" height="200" fill="${h.shadow}"/>
      <rect x="24" y="30" width="144" height="200" fill="${h.base}"/>
      <!-- 결 표현 -->
      <rect x="32" y="50" width="128" height="2" fill="${h.shadow}"/>
      <rect x="32" y="80" width="128" height="2" fill="${h.shadow}"/>
      <rect x="32" y="110" width="128" height="2" fill="${h.shadow}"/>
      <rect x="32" y="140" width="128" height="2" fill="${h.shadow}"/>
      <rect x="32" y="170" width="128" height="2" fill="${h.shadow}"/>
      <rect x="32" y="200" width="128" height="2" fill="${h.shadow}"/>
      <rect x="36" y="40" width="6" height="180" fill="${h.light}"/>
      <rect x="150" y="40" width="6" height="180" fill="${h.light}"/>
      <rect x="40" y="50" width="3" height="120" fill="${h.rim}"/>
      <rect x="149" y="50" width="3" height="120" fill="${h.rim}"/>
      <!-- 끝부분 (들쭉날쭉) -->
      <rect x="20" y="226" width="152" height="14" fill="${h.deep}"/>
      <rect x="28" y="240" width="14" height="6" fill="${h.shadow}"/>
      <rect x="56" y="240" width="14" height="6" fill="${h.shadow}"/>
      <rect x="84" y="240" width="14" height="6" fill="${h.shadow}"/>
      <rect x="112" y="240" width="14" height="6" fill="${h.shadow}"/>
      <rect x="140" y="240" width="14" height="6" fill="${h.shadow}"/>
    `,
    front: `
      <!-- 정수리 (덮음) -->
      <rect x="44" y="20" width="104" height="6" fill="${h.deep}"/>
      <rect x="40" y="26" width="112" height="10" fill="${h.shadow}"/>
      <rect x="40" y="36" width="112" height="20" fill="${h.base}"/>
      <rect x="44" y="36" width="104" height="4" fill="${h.light}"/>
      <rect x="60" y="38" width="20" height="3" fill="${h.rim}"/>
      <rect x="108" y="38" width="20" height="3" fill="${h.rim}"/>
      <!-- 앞머리 — 가운데에서 좌우로 -->
      <rect x="40" y="56" width="112" height="14" fill="${h.base}"/>
      <rect x="40" y="56" width="112" height="3" fill="${h.shadow}"/>
      <rect x="40" y="60" width="44" height="10" fill="${h.deep}"/>
      <rect x="108" y="60" width="44" height="10" fill="${h.deep}"/>
      <rect x="40" y="68" width="112" height="2" fill="${h.deep}"/>
    `,
  };
}

// ─── 신규 화려한 헤어 5종 — 모두 long 베이스 기반 ─────────────────────────

/** 무지개 롱 — 위에서 아래로 색이 변함 */
function hairRainbowLong(_c: string): HairSVGParts {
  const colors = ['#ff5050', '#ff9933', '#ffd95c', '#7fdc6c', '#5cc8ff', '#9b6bff'];
  const segHeight = 32;
  let backStripes = '';
  for (let i = 0; i < colors.length; i++) {
    const y = 40 + i * segHeight;
    const col = colors[i];
    backStripes += `
      <rect x="20" y="${y}" width="152" height="${segHeight}" fill="${col}" opacity="0.85"/>
      <rect x="24" y="${y}" width="144" height="${segHeight - 2}" fill="${col}"/>
      <rect x="36" y="${y + 2}" width="6" height="${segHeight - 4}" fill="#ffffff" opacity="0.4"/>
      <rect x="150" y="${y + 2}" width="6" height="${segHeight - 4}" fill="#ffffff" opacity="0.4"/>
    `;
  }
  return {
    back: `
      ${backStripes}
      <rect x="20" y="232" width="152" height="10" fill="#9b6bff"/>
      <rect x="36" y="242" width="14" height="6" fill="#7c4dcc"/>
      <rect x="84" y="242" width="14" height="6" fill="#7c4dcc"/>
      <rect x="132" y="242" width="14" height="6" fill="#7c4dcc"/>
    `,
    front: `
      <rect x="44" y="20" width="104" height="6" fill="#ff5050"/>
      <rect x="40" y="26" width="112" height="8" fill="#ff7070"/>
      <rect x="40" y="34" width="112" height="22" fill="#ff5050"/>
      <rect x="44" y="36" width="104" height="4" fill="#ffaaaa"/>
      <rect x="60" y="38" width="20" height="3" fill="#ffd0d0"/>
      <rect x="108" y="38" width="20" height="3" fill="#ffd0d0"/>
      <rect x="40" y="56" width="112" height="14" fill="#ff7733"/>
      <rect x="40" y="56" width="112" height="3" fill="#cc4400"/>
      <rect x="40" y="60" width="44" height="10" fill="#cc3030"/>
      <rect x="108" y="60" width="44" height="10" fill="#cc3030"/>
      <rect x="40" y="68" width="112" height="2" fill="#ff9933"/>
      <!-- 반짝이 -->
      <rect x="60" y="40" width="2" height="2" fill="#ffffff"/>
      <rect x="120" y="50" width="2" height="2" fill="#ffffff"/>
      <rect x="90" y="46" width="2" height="2" fill="#ffffff"/>
    `,
  };
}

/** 갤럭시 롱 */
function hairGalaxyLong(_c: string): HairSVGParts {
  const deepNavy = '#1a0f3a';
  const navy = '#2a1a5c';
  const purple = '#5a3a9c';
  const star = '#ffffff';
  const starGold = '#ffd95c';
  const starPositions = [[44,76],[60,100],[80,124],[100,80],[120,140],[140,90],[36,160],[156,180],[80,200],[120,200],[60,180],[140,160],[100,180],[50,140],[148,120]];
  const stars: string[] = [];
  for (const [sx, sy] of starPositions) {
    stars.push(`<rect x="${sx}" y="${sy}" width="2" height="2" fill="${star}"/>`);
    stars.push(`<rect x="${sx-1}" y="${sy+1}" width="4" height="1" fill="${star}" opacity="0.6"/>`);
    stars.push(`<rect x="${sx}" y="${sy-1}" width="1" height="4" fill="${star}" opacity="0.6"/>`);
  }
  stars.push(`<rect x="50" y="120" width="3" height="3" fill="${starGold}"/>`);
  stars.push(`<rect x="150" y="200" width="3" height="3" fill="${starGold}"/>`);
  stars.push(`<rect x="90" y="160" width="3" height="3" fill="${starGold}"/>`);
  return {
    back: `
      <rect x="20" y="30" width="152" height="200" fill="${deepNavy}"/>
      <rect x="24" y="30" width="144" height="200" fill="${navy}"/>
      <rect x="32" y="56" width="128" height="50" fill="${purple}" opacity="0.5"/>
      <rect x="32" y="140" width="128" height="50" fill="${purple}" opacity="0.4"/>
      ${stars.join('\n')}
      <rect x="20" y="226" width="152" height="14" fill="${deepNavy}"/>
      <rect x="56" y="240" width="14" height="6" fill="${navy}"/>
      <rect x="112" y="240" width="14" height="6" fill="${navy}"/>
    `,
    front: `
      <rect x="44" y="20" width="104" height="6" fill="${deepNavy}"/>
      <rect x="40" y="26" width="112" height="14" fill="${navy}"/>
      <rect x="40" y="40" width="112" height="30" fill="${navy}"/>
      <rect x="40" y="40" width="112" height="3" fill="${deepNavy}"/>
      <rect x="46" y="46" width="40" height="22" fill="${purple}" opacity="0.5"/>
      <rect x="106" y="46" width="40" height="22" fill="${purple}" opacity="0.5"/>
      <rect x="40" y="68" width="112" height="2" fill="${deepNavy}"/>
      <!-- 앞머리 별빛 -->
      <rect x="60" y="34" width="2" height="2" fill="${star}"/>
      <rect x="100" y="42" width="2" height="2" fill="${star}"/>
      <rect x="130" y="32" width="2" height="2" fill="${star}"/>
      <rect x="80" y="50" width="2" height="2" fill="${starGold}"/>
    `,
  };
}

/** 불꽃 롱 */
function hairFireLong(_c: string): HairSVGParts {
  const red = '#cc2020';
  const orange = '#ff6022';
  const yellow = '#ffaa20';
  return {
    back: `
      <rect x="20" y="30" width="152" height="200" fill="${red}"/>
      <rect x="24" y="30" width="144" height="200" fill="${orange}"/>
      <rect x="32" y="56" width="128" height="3" fill="${red}"/>
      <rect x="32" y="100" width="128" height="3" fill="${red}"/>
      <rect x="32" y="144" width="128" height="3" fill="${red}"/>
      <rect x="32" y="188" width="128" height="3" fill="${red}"/>
      <rect x="36" y="50" width="6" height="180" fill="${yellow}"/>
      <rect x="150" y="50" width="6" height="180" fill="${yellow}"/>
      <rect x="60" y="80" width="4" height="120" fill="${yellow}" opacity="0.5"/>
      <rect x="128" y="80" width="4" height="120" fill="${yellow}" opacity="0.5"/>
      <!-- 들쭉불꽃 끝 -->
      <polygon points="20,226 32,250 44,226 56,250 68,226 80,250 92,226 104,250 116,226 128,250 140,226 152,250 164,226 172,226" fill="${red}"/>
      <polygon points="24,226 32,244 42,226 56,244 66,226 80,244 90,226 104,244 114,226 128,244 138,226 152,244 162,226" fill="${orange}"/>
    `,
    front: `
      <rect x="44" y="20" width="104" height="6" fill="${red}"/>
      <rect x="40" y="26" width="112" height="10" fill="${red}"/>
      <rect x="40" y="36" width="112" height="22" fill="${orange}"/>
      <rect x="44" y="38" width="104" height="4" fill="${yellow}"/>
      <rect x="40" y="58" width="112" height="14" fill="${orange}"/>
      <rect x="40" y="58" width="112" height="3" fill="${red}"/>
      <rect x="40" y="62" width="44" height="10" fill="${red}"/>
      <rect x="108" y="62" width="44" height="10" fill="${red}"/>
      <rect x="40" y="70" width="112" height="2" fill="${yellow}"/>
      <!-- 양옆 위로 솟는 불꽃 -->
      <polygon points="14,46 28,28 38,52" fill="${orange}"/>
      <polygon points="18,46 26,32 36,50" fill="${yellow}"/>
      <polygon points="154,46 164,28 178,52" fill="${orange}"/>
      <polygon points="156,46 166,32 174,50" fill="${yellow}"/>
    `,
  };
}

/** 은빛 + 꽃 */
function hairSilverFlower(_c: string): HairSVGParts {
  const lightSilver = '#e8e8f0';
  const silver = '#c8c8d8';
  const darkSilver = '#9898a8';
  const flowerPink = '#ffb0d0';
  const flowerCenter = '#ffd95c';
  const sparkle = '#ffffff';
  return {
    back: `
      <rect x="20" y="30" width="152" height="200" fill="${darkSilver}"/>
      <rect x="24" y="30" width="144" height="200" fill="${silver}"/>
      <rect x="24" y="30" width="144" height="60" fill="${lightSilver}"/>
      <rect x="32" y="62" width="128" height="2" fill="${darkSilver}"/>
      <rect x="32" y="100" width="128" height="2" fill="${darkSilver}"/>
      <rect x="32" y="150" width="128" height="2" fill="${darkSilver}"/>
      <rect x="32" y="200" width="128" height="2" fill="${darkSilver}"/>
      <rect x="36" y="40" width="6" height="180" fill="${lightSilver}"/>
      <rect x="150" y="40" width="6" height="180" fill="${lightSilver}"/>
      <rect x="20" y="226" width="152" height="14" fill="${darkSilver}"/>
      <rect x="56" y="240" width="14" height="6" fill="${silver}"/>
      <rect x="120" y="240" width="14" height="6" fill="${silver}"/>
      <!-- 반짝이 -->
      <rect x="40" y="80" width="2" height="2" fill="${sparkle}"/>
      <rect x="156" y="100" width="2" height="2" fill="${sparkle}"/>
      <rect x="50" y="160" width="2" height="2" fill="${sparkle}"/>
      <rect x="146" y="180" width="2" height="2" fill="${sparkle}"/>
      <rect x="100" y="200" width="2" height="2" fill="${sparkle}"/>
    `,
    front: `
      <rect x="44" y="20" width="104" height="6" fill="${darkSilver}"/>
      <rect x="40" y="26" width="112" height="14" fill="${silver}"/>
      <rect x="40" y="40" width="112" height="16" fill="${lightSilver}"/>
      <rect x="44" y="40" width="104" height="3" fill="#ffffff"/>
      <rect x="60" y="42" width="20" height="3" fill="#ffffff"/>
      <rect x="108" y="42" width="20" height="3" fill="#ffffff"/>
      <rect x="40" y="56" width="112" height="14" fill="${silver}"/>
      <rect x="40" y="56" width="112" height="3" fill="${darkSilver}"/>
      <rect x="40" y="68" width="112" height="2" fill="${darkSilver}"/>
      <!-- 왼쪽 꽃 장식 -->
      <rect x="22" y="48" width="6" height="6" fill="${darkSilver}"/>
      <rect x="32" y="42" width="6" height="6" fill="${darkSilver}"/>
      <rect x="22" y="58" width="6" height="6" fill="${darkSilver}"/>
      <rect x="32" y="64" width="6" height="6" fill="${darkSilver}"/>
      <rect x="23" y="49" width="4" height="4" fill="${flowerPink}"/>
      <rect x="33" y="43" width="4" height="4" fill="${flowerPink}"/>
      <rect x="23" y="59" width="4" height="4" fill="${flowerPink}"/>
      <rect x="33" y="65" width="4" height="4" fill="${flowerPink}"/>
      <rect x="28" y="54" width="4" height="4" fill="${flowerCenter}"/>
      <!-- 오른쪽 꽃 장식 -->
      <rect x="158" y="48" width="6" height="6" fill="${darkSilver}"/>
      <rect x="148" y="42" width="6" height="6" fill="${darkSilver}"/>
      <rect x="158" y="58" width="6" height="6" fill="${darkSilver}"/>
      <rect x="148" y="64" width="6" height="6" fill="${darkSilver}"/>
      <rect x="159" y="49" width="4" height="4" fill="${flowerPink}"/>
      <rect x="149" y="43" width="4" height="4" fill="${flowerPink}"/>
      <rect x="159" y="59" width="4" height="4" fill="${flowerPink}"/>
      <rect x="149" y="65" width="4" height="4" fill="${flowerPink}"/>
      <rect x="154" y="54" width="4" height="4" fill="${flowerCenter}"/>
    `,
  };
}

/** 인어공주 — turquoise + pink wavy */
function hairPastelMermaid(_c: string): HairSVGParts {
  const teal = '#7feedb';
  const tealDark = '#4abfa8';
  const pink = '#ffb0d0';
  const pinkDark = '#cc88a8';
  const lavender = '#d8c8ff';
  return {
    back: `
      <rect x="20" y="30" width="152" height="50" fill="${tealDark}"/>
      <rect x="24" y="30" width="144" height="50" fill="${teal}"/>
      <rect x="20" y="80" width="152" height="50" fill="${pinkDark}"/>
      <rect x="24" y="80" width="144" height="50" fill="${pink}"/>
      <rect x="20" y="130" width="152" height="50" fill="${tealDark}"/>
      <rect x="24" y="130" width="144" height="50" fill="${teal}"/>
      <rect x="20" y="180" width="152" height="50" fill="${pinkDark}"/>
      <rect x="24" y="180" width="144" height="50" fill="${pink}"/>
      <rect x="36" y="40" width="6" height="40" fill="${lavender}"/>
      <rect x="150" y="40" width="6" height="40" fill="${lavender}"/>
      <rect x="36" y="100" width="6" height="40" fill="${lavender}"/>
      <rect x="150" y="100" width="6" height="40" fill="${lavender}"/>
      <rect x="36" y="160" width="6" height="40" fill="${lavender}"/>
      <rect x="150" y="160" width="6" height="40" fill="${lavender}"/>
      <!-- 웨이브 끝 -->
      <polygon points="20,226 36,250 52,226 68,250 84,226 100,250 116,226 132,250 148,226 172,250" fill="${pinkDark}"/>
      <polygon points="24,226 36,246 50,226 68,246 82,226 100,246 114,226 132,246 146,226 168,246" fill="${pink}"/>
    `,
    front: `
      <rect x="44" y="20" width="104" height="6" fill="${tealDark}"/>
      <rect x="40" y="26" width="112" height="10" fill="${teal}"/>
      <rect x="40" y="36" width="112" height="20" fill="${teal}"/>
      <rect x="44" y="38" width="104" height="4" fill="${lavender}"/>
      <rect x="60" y="40" width="20" height="3" fill="#ffffff"/>
      <rect x="108" y="40" width="20" height="3" fill="#ffffff"/>
      <rect x="40" y="56" width="112" height="14" fill="${pink}"/>
      <rect x="40" y="56" width="112" height="3" fill="${pinkDark}"/>
      <rect x="40" y="60" width="44" height="10" fill="${pinkDark}"/>
      <rect x="108" y="60" width="44" height="10" fill="${pinkDark}"/>
      <rect x="40" y="68" width="112" height="2" fill="${lavender}"/>
    `,
  };
}

export const HAIR_STYLES: Record<HairStyle, (c: string) => HairSVGParts> = {
  buns: hairBuns,
  twintails: hairTwintails,
  pony: hairPony,
  bob: hairBob,
  long: hairLong,
  rainbow_long: hairRainbowLong,
  galaxy_long: hairGalaxyLong,
  fire_long: hairFireLong,
  silver_flower: hairSilverFlower,
  pastel_mermaid: hairPastelMermaid,
  // braids는 AI 오버레이로만 처리되니 SVG fallback은 long으로 대체
  braids: hairLong,
};
